import React from 'react';

import { Container } from 'reactstrap';
import { CollapseToggle } from '~/components/Collapse';
import { Text } from '~/components/Text';
import { SubHeader } from '~/components/SubHeader';

function MaquinaVirtual() {
	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Perguntas Frequentes',
						link: '/client/faq',
					},
					{
						page: 'Lucree por click',
						link: '/client/faq/maquina-virtual',
					},
				]}
			/>
			<Text size="large" className="my-5">
				Lucree por click
			</Text>
			<CollapseToggle title="Como gerar um link de pagamento? 1">
				Anim pariatur cliche reprehenderit, enim eiusmod high life
				accusamus terry richardson ad squid. Nihil anim keffiyeh
				helvetica, craft beer labore wes anderson cred nesciunt sapiente
				ea proident.
			</CollapseToggle>
			<CollapseToggle title="Como gerar um link de pagamento? 2">
				Anim pariatur cliche reprehenderit, enim eiusmod high life
				accusamus terry richardson ad squid. Nihil anim keffiyeh
				helvetica, craft beer labore wes anderson cred nesciunt sapiente
				ea proident.
			</CollapseToggle>
			<CollapseToggle title="Como gerar um link de pagamento? 3">
				Anim pariatur cliche reprehenderit, enim eiusmod high life
				accusamus terry richardson ad squid. Nihil anim keffiyeh
				helvetica, craft beer labore wes anderson cred nesciunt sapiente
				ea proident.
			</CollapseToggle>
		</Container>
	);
}

export default MaquinaVirtual;
